import { type ModalEntry, type ModalOpenResult, useModalStore } from '@tix/modal'

import SelectionSummary, { type SelectionSummaryProps } from '@/components/bundles/selections/SelectionSummary.vue'

export const SELECTIONS_MODAL_NAME = 'flow-selections'

/** The parts of the summary that track the flow, and so have to be re-sent while the sheet is open. */
export type SelectionsModalContent = Pick<SelectionSummaryProps, 'rows' | 'subtotal'>

type EditHandler = (resolverId: string, type?: string) => void

export type OpenSelectionsModalProps = SelectionsModalContent & {
  title?: string
  closeLabel?: string
  onEdit?: EditHandler
}

function summaryProps(content: SelectionsModalContent, onEdit?: EditHandler): Record<string, unknown> {
  const modal = useModalStore()

  return {
    ...content,
    surface: 'plain',
    onEdit: (resolverId: string, type?: string) => {
      modal.close(SELECTIONS_MODAL_NAME)
      onEdit?.(resolverId, type)
    },
  }
}

/** Bottom sheet on mobile. `closeable: false` matches Figma (footer Close only). TODO TIC-6248 Escape is gated on `closeable`. */
export function openSelectionsModal({
  title = 'Your selections',
  closeLabel = 'Close',
  onEdit,
  ...content
}: OpenSelectionsModalProps): ModalOpenResult {
  const modal = useModalStore()

  return modal.open({
    component: SelectionSummary,
    name: SELECTIONS_MODAL_NAME,
    title,
    size: 'lg',
    dismissible: true,
    closeable: false,
    actions: [
      {
        label: closeLabel,
        hierarchy: 'secondary',
        intent: 'confirm',
        onAction: (close) => close(),
      },
    ],
    props: summaryProps(content, onEdit),
  })
}

export function updateSelectionsModal(content: SelectionsModalContent, onEdit?: EditHandler): ModalEntry | undefined {
  const modal = useModalStore()

  return modal.update(SELECTIONS_MODAL_NAME, { props: summaryProps(content, onEdit) })
}
